import request from '../js/request';

export const getAd = (data) => {
  return request({
    url: '/getAd',
    method: 'post',
    data,
  });
};

export const getArticleClass = (data) => {
  return request({
    url: '/getArticleClass',
    method: 'post',
    data: data,
  });
};

export const getArticle = (data) => {
  return request({
    url: '/getArticle',
    method: 'post',
    data: data,
  });
};

export const getArticleById = (data) => {
  return request({
    url: '/getArticleById',
    method: 'post',
    data: data,
  });
};
